export enum enumCustomerSourceType {
    Manual = 1,
    Lead = 2
};